import {
  CustomPropertyEntityTypeEnum,
  CustomPropertyTypeEnum,
} from '../../../shared/models';

export interface DefaultCustomPropertyOption {
  key: string;
  label: string;
  position: number;
}

export interface DefaultCustomProperty {
  key: string;
  label: string;
  targetEntity: CustomPropertyEntityTypeEnum;
  type: CustomPropertyTypeEnum;
  settings?: unknown | null;
  options?: DefaultCustomPropertyOption[];
}

export const DEFAULT_CUSTOM_PROPERTIES: DefaultCustomProperty[] = [
  {
    key: 'is_pep',
    label: 'Is PEP',
    targetEntity: CustomPropertyEntityTypeEnum.individual,
    type: CustomPropertyTypeEnum.boolean,
    settings: null,
  },
  {
    key: 'ownership_type',
    label: 'Ownership type',
    targetEntity: CustomPropertyEntityTypeEnum.individual,
    type: CustomPropertyTypeEnum.choices,
    settings: { allowMultiple: false },
    options: [
      {
        key: 'direct',
        label: 'Direct rights (shares or votes)',
        position: 1,
      },
      {
        key: 'indirect',
        label: 'Indirect rights (shares or votes)',
        position: 2,
      },
      {
        key: 'ubo_legal_representative',
        label: 'UBO Legal representative',
        position: 3,
      },
      {
        key: 'other_significant_control',
        label: 'Other significant control',
        position: 4,
      },
    ],
  },
];
